import React from 'react'
import PropTypes from 'prop-types'
import Popup from 'reactjs-popup'
import {
  ButtonContainer,
  Button,
  Card
} from 'camino-react'

import { cloudhelpPost } from 'Utilities/CloudHelp'
import Modal from 'Components/Modal'
import { isEmpty } from 'lodash'

class Resolve extends React.Component {
  constructor (props) {
    super(props)
    const { tickets } = this.props
    this.state = {
      submitButtonProps: {
        text: isEmpty(tickets) ? 'Close problem' : 'Resolve all',
        color: 'danger'
      }
    }

    this.submit = this.submit.bind(this)
  }

  submit () {
    const { paths, setAlert, closeProblemModal, closeModal } = this.props
    const { closeProblemPath } = paths

    this.setState({
      submitButtonProps: {
        text: 'Resolving...',
        color: 'danger',
        disabled: true
      }
    })

    cloudhelpPost(closeProblemPath)
      .then((response) => {
        closeProblemModal()
        this.setState({
          submitButtonProps: {
            text: 'Resolved',
            color: 'success'
          }
        }, () => { closeModal(); window.location.reload() })

        setAlert(
          'Tickets resolved and problem closed successfully',
          'success'
        )
      })
      .catch((error) => {
        this.setState({
          submitButtonProps: {
            text: 'Resolve all',
            color: 'danger'
          },
        }, () => closeModal())

        setAlert(
          error.response.data.errors.concat(' '),
          'error',
          true
        )
      })
  }

  render () {
    const { tickets, showModal, closeModal } = this.props
    const { submitButtonProps } = this.state
    const { text: submitButtonText } = submitButtonProps
    const resolveTicketsText = `You are about to resolve
    ${tickets.length} tickets
    associated with this problem.
    Resolving these tickets will update all open tickets with the root cause, preventive action and corrective action, and close the problem`

    return (
      <Modal showModal={showModal} title="Warning!" warning removeModal={() => closeModal()}>
        <Card flat padding="xsmall">
          <p style={{ fontSize: '18px' }}>
            {isEmpty(tickets) ? 'Are you sure to close problem?' : resolveTicketsText}
          </p>
        </Card>
        <ButtonContainer center spaced>
          <Button color="dark" outline onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button onClick={() => this.submit()} {...submitButtonProps}>
            {submitButtonText}
          </Button>
        </ButtonContainer>
      </Modal>
    )
  }
}

Resolve.propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.object).isRequired,
  problem: PropTypes.shape({}).isRequired,
  paths: PropTypes.shape({}).isRequired,
  setAlert: PropTypes.func.isRequired
}

export default Resolve
